import { blockFieldInfo } from "@caredna-marlin/utils/calendarBlockHelper";
import { Availability } from "@caredna-marlin/utils/client/availability";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { startCase } from "lodash";
import AddressForm from "~/components/common/forms/AddressForm";
import LabeledCheckboxSelect from "~/components/common/forms/LabeledCheckboxSelect";
import { OrgConfigQuery, useCommandIndexProvidersQuery } from "~/graphql/__generated__/graphql";
import { useOrgConfig } from "~/providers/OrgConfigProvider";
import { filteredProviderVisitTypes } from "~/utils/providers";

type Props = {
  disabled?: boolean,
  edited: Availability,
  setEdited: (a: Availability) => void,
}

const EditAvailabilityBlock = ({ disabled, edited, setEdited }: Props) => {
  const { data } = useCommandIndexProvidersQuery({ variables: { includeShifts: false, start: null, end: null, active: true }});

  const provider = data?.commandIndexProviders?.providers?.find((p) => p.id === edited.providerId);
  const { visitTypes } = useOrgConfig();

  const parsedVisitTypes = Object.values(visitTypes) as Partial<OrgConfigQuery["visitType"][number][]>;

  // filter visit types by provider service lines visit types.
  const filteredVisitTypes = filteredProviderVisitTypes(provider, parsedVisitTypes)?.map((vt) => ({ key: vt.id, label: startCase(vt.name) }));
   
  const info = blockFieldInfo(edited.blockType);

  return <>
    {/* Address only for Meeting or Facility */}
    {info.showAddress && (<>
      <Grid size={3}><span>
        Address
        {info.requiredAddress && !edited.addressStreet && <Typography color="error" component="span">*</Typography>}
      </span></Grid>
      <Grid size={9}>
        <AddressForm
          disabled={disabled}
          sx={{ mt: -1, mb: -1 }}
          skipLineTwo
          label=""
          variant="outlined"
          address={edited}
          size="small"
          setAddress={(address) => setEdited({ ...edited, ...address })}
        />
      </Grid>
    </>)}

    {/* Visit Types for Facility or Visit type */}
    {info.showVisitType && (<>
      <Grid size={3}><span>
        Visit Types
        {info.shouldRequireVisitTypes && !edited.blockFilters?.visitTypeIds?.length && <Typography color="error" component="span">*</Typography>}
      </span></Grid>
      <Grid size={9}>
        {filteredVisitTypes?.length ? <LabeledCheckboxSelect
          label=""
          fullWidth
          disabled={disabled}
          value={edited.blockFilters?.visitTypeIds || []}
          onChange={(visitTypeIds: number[]) =>
            setEdited({
              ...edited,
              blockFilters: { visitTypeIds },
            })
          }
          options={filteredVisitTypes}
          required={false}
        /> : (
          'Provider has no visit types assigned'
        )}
      </Grid>
    </>)}
  </>
}

export default EditAvailabilityBlock;
